import apiClient from '../config/api';

const ENDPOINTS = {
    GIFTCARDS: '/api/giftcards',
    GIFTCARD_BY_NO: (giftcardNo) => `/api/giftcards/${giftcardNo}`,
    ACTIVATE_GIFTCARD: '/api/giftcards/activategiftcard',
};

export const giftcardService = {
    // Get all giftcards with pagination and sorting
    getGiftcards: async (params = {}) => {
        const response = await apiClient.get(ENDPOINTS.GIFTCARDS, { params });
        return response.data;
    },

    // Get giftcard by giftcard number
    getGiftcardByNo: async (giftcardNo) => {
        const response = await apiClient.get(ENDPOINTS.GIFTCARD_BY_NO(giftcardNo));
        return response.data;
    },

    // Get giftcard details for portal
    getGiftcardDetails: async (giftcardNo) => {
        const response = await apiClient.get(`${ENDPOINTS.GIFTCARDS}/${giftcardNo}/details`);
        return response.data;
    },

    // Activate giftcard from customer portal
    activateGiftcard: async (activationData) => {
        const response = await apiClient.post(ENDPOINTS.ACTIVATE_GIFTCARD, activationData);
        return response.data;
    },

    // Reset PIN for an activated giftcard
    resetPIN: async (giftcardNo, newPIN) => {
        const response = await apiClient.post(`/api/giftcards/${giftcardNo}/reset-pin`, {
            newPIN
        });
        return response.data;
    },
};

export default giftcardService;
